/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transfer_Dialog_Move_ArtifactInputs */



/**
* | output |
* | --- |
* | "Move Artifact" |
*
* @param {Transfer_Dialog_Move_ArtifactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const transfer_dialog_move_artifact = /** @type {((inputs?: Transfer_Dialog_Move_ArtifactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transfer_Dialog_Move_ArtifactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakt verschieben")
	return /** @type {LocalizedString} */ ("Move Artifact")
});